import { closeDialogByName, openDialog } from '@patrianna/dialog-manager'
import { setIsRedeeming } from '@patrianna-payments/shared-store/redeem'
import type { KYCVerificationIframeParams } from '@patrianna-payments/shared-store/verifications/hooks/docs-verification/useKYCVerificationIframe'
import {
  verificationsKYCInfoResponseActionName,
  verificationsKYCInfoResponseErrorActionName,
  verificationsSetIsRedeemingActionName,
  verificationsSetKycStatusActionName,
} from '@patrianna-payments/shared-store/verifications/store/actions'
import { verificationsSlice } from '@patrianna-payments/shared-store/verifications/store/slice'
import type { AnyAction } from '@reduxjs/toolkit'

import { setKycStatus } from 'store/modules/kyc/actions'
import { openSnackbar } from 'store/modules/snackbar/actions'
import type { TypedThunk } from 'store/types'

import type { MiddlewareType } from './types'

const handleKYCInfoResponseAction =
  (response: KYCVerificationIframeParams): TypedThunk =>
  (dispatch) => {
    closeDialogByName({ dialogName: 'WITHDRAW_DIALOG' })
    closeDialogByName({ dialogName: 'SUBMIT_DOCUMENTS_DIALOG' })
    closeDialogByName({ dialogName: 'GET_VERIFIED_DIALOG' })
    openDialog({ dialogName: 'VERIFICATION_KYC_DIALOG', dialogProps: response })

    dispatch(setIsRedeeming({ isRedeeming: false }))
  }

export const verificationsMiddleware: MiddlewareType =
  ({ dispatch }) =>
  (next) =>
  (action: AnyAction) => {
    if (action?.type?.includes(verificationsSlice.name)) {
      if (action.type === verificationsKYCInfoResponseActionName) {
        dispatch(handleKYCInfoResponseAction(action.payload))
      }

      if (action.type === verificationsSetIsRedeemingActionName) {
        dispatch(setIsRedeeming(action.payload))
      }

      if (action.type === verificationsSetKycStatusActionName) {
        dispatch(setKycStatus(action.payload))
      }

      if (action.type === verificationsKYCInfoResponseErrorActionName) {
        dispatch(openSnackbar({ message: action.payload.error }))
      }
    }

    next(action)
  }
